// This form allows user to fill out the form and company owner will know how to prepare for user answer


import React from "react";
import UserWelcomeFormTables from "../components/UserWelcomeFormTables";

//import button from material design
import Button from '@mui/material/Button';
// import BasicRating from "../materialComponents/BasicRating";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import {Paper} from "@mui/material";
import Typography from "@mui/material/Typography";
import SliderSizes from "../materialComponents/SliderSizes";



const UserWelcomeForm = () => {



    return (
        <>



        <div id="registerPage" className="container-fluid"
        >

            <div className="container">
                <div className="row">
                    <div className="col s2"></div>
                    <div className="col s8">
                        <p id="PageTitleRegister"> User Welcome Form</p>
                        {/*<p> Please complete all mandatory fields.</p>*/}
                    </div>
                    <div className="col s2"></div>
                </div>
            </div>

            <div className="row">

                {/*<Register/>*/}
                {/*<RegisterJWT/>*/}
                <UserWelcomeFormTables/>
                <SliderSizes/>
            </div>



        {/*<BasicRating></BasicRating>*/}




            <Button variant="contained">Hello world</Button>



        </div>
        </>
            );

}

export default UserWelcomeForm ;